// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.SelectV2_popper {\n  width: 170px;\n}\n", ""]);
// Exports
module.exports = exports;
